(function () {
    'use strict';

    angular.module('modules.page_fix.pages', ['blocks.router']);
})();
